import template from './states-templates.html';
import controller from './states-templates.controller';

let statesTemplatesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default statesTemplatesComponent;
